import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowLeft,
  faArrowRight,
  faBars,
  faCaretDown,
  faCartPlus,
  faCheck,
  faCheckCircle,
  faCog,
  faCopy,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExternalLinkAlt,
  faExclamationCircle,
  faHeart,
  faHome,
  faInfoCircle,
  faMinus,
  faPaperclip,
  faPaperPlane,
  faPencilAlt,
  faPlus,
  faQuestionCircle,
  faSearch,
  faShare,
  faShoppingCart,
  faSignInAlt,
  faSignOutAlt,
  faSlash,
  faSpinner,
  faTimes,
  faTimesCircle,
  faTrash,
  faTruck,
  faUser,
  faWrench,
} from "@fortawesome/free-solid-svg-icons"

// define fontawesome icons used in the app
library.add(
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowLeft,
  faArrowRight,
  faBars,
  faCaretDown,
  faCartPlus,
  faCheck,
  faCheckCircle,
  faCog,
  faCopy,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExclamationCircle,
  faExternalLinkAlt,
  faHeart,
  faHome,
  faInfoCircle,
  faMinus,
  faPaperclip,
  faPaperPlane,
  faPencilAlt,
  faPlus,
  faQuestionCircle,
  faSearch,
  faShare,
  faShoppingCart,
  faSignInAlt,
  faSignOutAlt,
  faSlash,
  faSpinner,
  faTimes,
  faTimesCircle,
  faTrash,
  faTruck,
  faUser,
  faWrench,
)

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default library
